<template>
  <div class="public-header">
    <div class="p-d-flex p-justify-between">
      <div>
        <img
          :src="getLogoUrl"
          class="public-page-logo cursorpointer"
          alt="Diamond Scheduler logo"
          @click="goRouter(`/public/${domain}`)"
        />
        <a href="https://cactusware.com">
          <div class="powered-by-container" v-if="logoUrl">
            Powered by
            <img
              src="https://diamond-public.s3.us-west-2.amazonaws.com/assets/diamond-logo-white.png"
              width="100"
              alt="DS Logo"
            />
          </div>
        </a>
      </div>

      <div class="links-gap normalWeight">
        <span @click="goRouter(`/public/${domain}`)">HOME</span>
        <div class="dropdown-link-area" v-if="showTeamsPage">
          <span class="dropdown-link">TEAMS</span>
          <div class="dropdown-link-content">
            <div v-for="t in teams" :key="t.id" @click="goRouter(`/public/${domain}/team/${t.id}`)">
              {{ t.name }}
            </div>
          </div>
        </div>
        <span @click="goRouter(`/public/${domain}/standings`)" v-if="showStandingsPage">STANDINGS</span>
        <span @click="goRouter(`/public/${domain}/schedules`)" v-if="showSchedulesPage">SCHEDULES</span>
        <span @click="goRouter(`/public/${domain}/scores`)" v-if="showScoresPage">SCORES</span>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";

export default {
  props: [
    "seasonId",
    "showTeamsPage",
    "showStandingsPage",
    "showSchedulesPage",
    "showScoresPage",
    "showRostersPage",
    "logoUrl",
    "domain",
  ],
  data() {
    return {
      teams: [],
    };
  },
  methods: {
    fetchData(seasonId) {
      api.getSeasonTeams(seasonId).then(response => {
        this.teams = response.data;
      });
    },
  },
  computed: {
    getLogoUrl() {
      const defaultLogoUrl = "https://diamond-public.s3.us-west-2.amazonaws.com/assets/diamond-logo-white.png";
      if (this.logoUrl) {
        return this.logoUrl;
      } else {
        return defaultLogoUrl;
      }
    },
  },
  mounted() {
    if (this.seasonId) this.fetchData(this.seasonId);
  },
};
</script>
